// Keep our own copy of the appearanceStyles. Updates sent via sendUpdate from eden-style-constants as the Appearance Constants are set. This keeps us from having to expose a "getAllAppearanceStyles" from eden-style-constants which would become a public API to worry about.
const appearanceStyles = {};
appearanceStyles.light = {};
appearanceStyles.dark = {};
export const getAllModeStyles = mode => {
  const curMode = appearanceStyles[mode];
  const appearanceString = Object.keys(curMode).map(key => `${key}: ${curMode[key]};`).join(`
`);
  return appearanceString;
};
export const sendUpdate = (name, values) => {
  appearanceStyles.light[name] = values.light;
  appearanceStyles.dark[name] = values.dark;
};